import vslQueries from "$/lib/queries/vsl-queries"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const TABS = ["stats", "versions", "links", "submissions"] as const

export const Route = createFileRoute("/(app)/_auth/vsl/$vslId/")({
  validateSearch: z.object({ tab: z.enum(TABS).catch("stats") }),
  loader: async ({ context: { queryClient }, params: { vslId } }) => {
    const vsl = await queryClient.ensureQueryData(vslQueries.detail(vslId))
    return { crumb: vsl.title }
  },
})
